
import { BaseModel } from '../abstracts/base.model'

export class ClassModel extends BaseModel {
  ClassID: string
  TermID: string
  ClassroomID: string
  ClassLevelID: string
  ClassName: string
  TrainingID: string
  StartDate: Date
  EndDate: Date
  ManagerName: string
  ClassCode: string
  StatusID: string
  ClassCapacity: string
  Total: number
  AssessmentTemplateID: string

  
  AssessmentTemplateName: string

  ClassroomCode: string
  ClassLevel: string
  InstructorName: string
  TrainingName: string
  CompanyName: string
  ClassCount: string
  isCheck: boolean
  ParticipantIDs: any[] = []
  ManagerID: string
  IsMail:boolean
  MailTitle:string
  MailDescription:string
}